











































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SoportePlanificadores extends Vue {
  public mounted() {
    // Componente puramente informativo
  }
}
